import { useTheme } from 'foundations-theming/utils';
import { rgba } from '../../utils/color';
export const useRingColor = use => {
  const theme = useTheme();
  switch (use) {
    case 'on-dark':
    case 'secondary-ghost':
      return rgba(theme.color['fill-inverse-default-alt'], 0.21);
    case 'danger':
    case 'primary':
    case 'secondary':
    case 'secondary-alt':
      return theme.color['temp-future-fill-secondary-pressed'];
    case 'primary-white':
    case 'primary-on-fill':
    case 'tertiary-on-fill':
    case 'tertiary':
    case 'tertiary-light':
    case 'tertiary-extra-light':
    case 'tertiary-transparent':
      return theme.color['fill-accent-neutral-subtle-alt'];
    case 'success':
      return theme.color['border-core-disabled'];
    case 'link':
      return rgba(theme.color['icon-interactive-default'], 0.21);
    default:
      {
        const __exhaustiveCheck = use;
        throw new Error(`Unhandled \`use\` argument:\n ${use}`);
      }
  }
};
export const useIndicatorColor = use => {
  const theme = useTheme();
  switch (use) {
    case 'danger':
      return theme.color['fill-alert-default'];
    case 'primary':
    case 'secondary':
    case 'secondary-alt':
      return theme.color['fill-primary-default'];
    case 'primary-white':
    case 'primary-on-fill':
    case 'tertiary-on-fill':
    case 'tertiary':
    case 'tertiary-light':
    case 'tertiary-extra-light':
    case 'tertiary-transparent':
      return theme.color['icon-tertiary-default'];
    case 'success':
      return theme.color['fill-positive-default'];
    case 'on-dark':
    case 'secondary-ghost':
      return theme.color['fill-inverse-default-alt'];
    case 'link':
      return theme.color['icon-interactive-default'];
    default:
      {
        const __exhaustiveCheck = use;
        throw new Error(`Unhandled \`use\` argument:\n ${use}`);
      }
  }
};